const OVERLAY_DEFAULTS = { tileSize: 256, opacity: 0.8, visible: false }

const STACKABLE_OVERLAYS = ['species', 'custom']

export const overlaysStack = (a, b) => STACKABLE_OVERLAYS.includes(a) && STACKABLE_OVERLAYS.includes(b)

export const MAP_OVERLAYS = {
  topo: {
    ...OVERLAY_DEFAULTS,
    maxSourceZoom: 16,
    maxZoom: 16,
    tileUrl: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSTopo/MapServer/tile/{z}/{y}/{x}'
  }
}
